import { t } from "@lingui/macro";

export const TermsPage = () => (
  <main className="container py-24">
    <h1 className="text-4xl font-bold">{t`Terms of Service`}</h1>
  </main>
);
